import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { Product } from './Product';

export class ProductResource extends FBaseService {
  public async getAllProducts(fiId: string): Promise<Product[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/config/${fiId}/product`,

    );
    const results: Product[] = response.data.data;
    return results;
  }
}

export default ProductResource;
